"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const safe_get_1 = require("../../../../../libs/safe-get");
const getImageVisibility = (hide, inherit) => {
    if (hide) {
        return 'hideImage';
    }
    if (inherit) {
        return 'inherit';
    }
    return 'showImage';
};
exports.importData = {
    import(data, actions) {
        const importValues = exports.importData.getAllImportValues(data);
        const tabNames = Object.keys(importValues);
        tabNames.forEach(tabName => {
            exports.importData.setStateForTab({ actions, importValues: importValues[tabName], tabName });
        });
    },
    setStateForTab({ actions, importValues, tabName, }) {
        actions.effects.changeImageUrl({
            tabName,
            imageUrl: importValues.imageUrl,
        });
        actions.effects.changeContainerDimensions({
            tabName,
            dimensionType: 'original',
            changes: {
                widthValue: importValues.originalWidthValue,
                widthFormat: importValues.originalWidthFormat,
                heightValue: importValues.originalHeightValue,
                heightFormat: importValues.originalHeightFormat,
            },
        });
        actions.effects.changeContainerDimensions({
            tabName,
            dimensionType: 'active',
            changes: {
                widthValue: importValues.activeWidthValue,
                widthFormat: importValues.activeWidthFormat,
                heightValue: importValues.activeHeightValue,
                heightFormat: importValues.activeHeightFormat,
            },
        });
        actions.effects.changeAlternateText({
            tabName,
            imageAlternativeText: importValues.imageAlternativeText,
        });
        actions.setters.setImageVisibilityState({
            tabName,
            imageVisibilityState: importValues.imageVisibility,
        });
        actions.setters.setInitialStyle({
            initialStyle: importValues.initialStyle,
        });
    },
    getAllImportValues(data) {
        const tabNames = Object.keys(data);
        return tabNames.reduce((state, tabName) => {
            const tabData = data[tabName];
            const originalImportValues = exports.importData.getDataImportValues(tabData.original);
            const activeImportValues = exports.importData.getDataImportValues(tabData.active);
            const importValues = exports.importData.getImportValues(originalImportValues, activeImportValues);
            state[tabName] = importValues;
            return state;
        }, {});
    },
    getImportValues(originalImportValues, activeImportValues) {
        const originalStyle = getStyleFromString(originalImportValues.style || '');
        const originalWidth = getDimension(originalImportValues.width, originalStyle.getPropertyValue('width'));
        const originalHeight = getDimension(originalImportValues.height, originalStyle.getPropertyValue('height'));
        const initialStyle = getValueByPrio(originalImportValues.style, '');
        const activeStyle = getStyleFromString(initialStyle);
        const activeWidth = getDimension(getValueByPrio(activeImportValues.width, originalImportValues.width, ''), activeStyle.getPropertyValue('width'));
        const activeHeight = getDimension(getValueByPrio(activeImportValues.height, originalImportValues.height, ''), activeStyle.getPropertyValue('height'));
        const src = getValueByPrio(activeImportValues.src, originalImportValues.src, '');
        const alt = getValueByPrio(activeImportValues.alt, originalImportValues.alt, '');
        const inherit = getValueByPrio(activeImportValues.inherit, originalImportValues.inherit, undefined);
        const hide = getValueByPrio(activeImportValues.hide, originalImportValues.hide, false);
        const imageVisibility = getImageVisibility(hide, !!inherit);
        return {
            originalWidthValue: originalWidth.dimensionValue,
            originalWidthFormat: originalWidth.dimensionFormat,
            originalHeightValue: originalHeight.dimensionValue,
            originalHeightFormat: originalHeight.dimensionFormat,
            activeWidthValue: activeWidth.dimensionValue,
            activeWidthFormat: activeWidth.dimensionFormat,
            activeHeightValue: activeHeight.dimensionValue,
            activeHeightFormat: activeHeight.dimensionFormat,
            imageAlternativeText: alt,
            imageUrl: src,
            imageVisibility,
            initialStyle,
        };
    },
    getDataImportValues(data = {}) {
        const inherit = safe_get_1.safeGet(() => data.inherit);
        const hide = safe_get_1.safeGet(() => data.hide);
        const width = safe_get_1.safeGet(() => data.attributes.width);
        const height = safe_get_1.safeGet(() => data.attributes.height);
        const style = safe_get_1.safeGet(() => data.attributes.style);
        const src = safe_get_1.safeGet(() => data.attributes.src);
        const alt = safe_get_1.safeGet(() => data.attributes.alt);
        return {
            inherit,
            hide,
            width,
            height,
            style,
            src,
            alt,
        };
    },
};
function getValueByPrio(...values) {
    for (const value of values) {
        if (value !== undefined) {
            return value;
        }
    }
    return values.slice(-1)[0];
}
function getStyleFromString(text) {
    const parser = new DOMParser();
    const doc = parser.parseFromString('<div />', 'text/html');
    const $div = doc.querySelector('div');
    $div.style.cssText = text;
    return $div.style;
}
function getDimension(attr, style) {
    if (style) {
        if (!style.includes('auto')) {
            if (style.includes('%')) {
                return {
                    dimensionValue: '' + parseInt(style, 10),
                    dimensionFormat: '%',
                };
            }
            return {
                dimensionValue: '' + parseInt(style, 10),
                dimensionFormat: 'px',
            };
        }
    }
    if (attr) {
        return {
            dimensionValue: attr,
            dimensionFormat: 'px',
        };
    }
    return {
        dimensionValue: undefined,
        dimensionFormat: 'auto',
    };
}
//# sourceMappingURL=import-data.js.map